import React, { useEffect } from "react";
import axios from "axios";
import keycloak from "../lib/keycloak";

const SSOCallback: React.FC = () => {

    useEffect(() => {

        const loginWithKeycloak = async () => {

            try {

                // Read fallback data from URL params (sent by Keycloak landing page)
                const params   = new URLSearchParams(window.location.search);
                const role     = params.get("role") || "";
                const empCode  = params.get("employeeCode") || "";
                const userId   = params.get("userId") || "";
                const empName  = params.get("tenantName") || "";
                const redirect = params.get("redirect") || "/HRDashboard";

                // Init Keycloak to get real Keycloak token
                const authenticated = await keycloak.init({
                    onLoad: "check-sso",
                    checkLoginIframe: false,
                    pkceMethod: "S256",
                    redirectUri: `${window.location.origin}/sso-callback`
                });

                console.log("Keycloak authenticated:", authenticated);

                if (!authenticated) {
                    // Not authenticated — store URL param fallback data and redirect
                    console.warn("Keycloak not authenticated, using URL param fallback");

                    localStorage.setItem("loginType", "keycloak");
                    if (role)    localStorage.setItem("UserRole",    role);
                    if (empCode) localStorage.setItem("empCode",     empCode);
                    if (userId)  localStorage.setItem("SignupEmpId", userId);
                    if (empName) localStorage.setItem("EmpName",     empName);

                    window.location.href = `${window.location.origin}/#${redirect}`;
                    return;
                }

                console.log("Keycloak token:", keycloak.token);

                localStorage.setItem("loginType", "keycloak");
                localStorage.setItem("kc_token",  keycloak.token || "");

                // Call Java backend with real Keycloak token
                const response = await axios.post(
                    `${process.env.REACT_APP_ICPANEL_URL}auth/keycloak-login`,
                    { keycloakToken: keycloak.token }
                );

                console.log("Backend Login Response:", response.data);

                if (response.data.token) {
                    localStorage.setItem("token", response.data.token);
                }
                if (response.data.UserRole) {
                    const roles = response.data.UserRole.split(",");
                    localStorage.setItem("UserRole", roles);
                }
                if (response.data.empCode) {
                    localStorage.setItem("empCode", response.data.empCode);
                }
                if (response.data.SignupEmpId) {
                    localStorage.setItem("SignupEmpId", response.data.SignupEmpId);
                }
                if (response.data.EmpName) {
                    localStorage.setItem("EmpName", response.data.EmpName);
                }

                window.location.href = `${window.location.origin}/#${redirect}`;

            } catch (error) {
                console.error("Keycloak SSO login failed:", error);
            }
        };

        loginWithKeycloak();

    }, []);

    return (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
            <h3>Signing in with Keycloak...</h3>
        </div>
    );
};

export default SSOCallback;
